import { useState } from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Link } from 'react-router-dom';
import mezzoFull from '../assets/images/mezzo-full.png';
import { Message } from 'primereact/message';
import { useLogin } from '@mezzodevelopment/mezzo-ui/auth';
import { FormInputText } from '../components/form';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

const Login = (): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const { handleLogin, isPasswordRequired, isLoading } = useLogin();

  const validationSchema = yup.object({
    username: yup.string().required('Please enter your username').trim(),
    password: yup.string().when([], {
      is: () => isPasswordRequired,
      then: (schema) => schema.required('Please enter your password').trim(),
      otherwise: (schema) => schema.trim(),
    }),
  });

  const {
    control,
    formState: { errors: formErrors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      username: '',
      password: '',
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data: { username: string; password?: string }) => {
    try {
      setErrorMessage(null);
      if (isPasswordRequired) {
        await (handleLogin as any)({ username: data.username, password: data.password });
      } else {
        await (handleLogin as any)({ username: data.username });
      }
    } catch (error) {
      setErrorMessage('Invalid credentials. Please try again.');
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="logo-container p-text-center">
          <Link to="/">
            <img src={mezzoFull} alt="Logo" className="logo" />
          </Link>
        </div>
        {errorMessage && (
          <div className="p-fluid p-mb-3">
            <Message severity="error" className="mb-3" text={errorMessage} />
          </div>
        )}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        >
          <div className="grow p-fluid p-input-filled">
            <FormInputText
              key={'username'}
              control={control}
              errors={formErrors}
              field={'username'}
              label={'Username'}
              disabled={isLoading}
            />

            {isPasswordRequired && (
              <>
                <FormInputText
                  key={'password'}
                  control={control}
                  errors={formErrors}
                  field={'password'}
                  label={'Password'}
                  disabled={isLoading}
                  type="password"
                  autoFocus={true}
                />
              </>
            )}
            <Button
              label={isLoading ? 'Please wait...' : 'Login'}
              icon={isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-sign-in'}
              loading={isLoading}
              className="p-button-block p-mt-3"
              type="submit"
            />
          </div>
        </form>
      </Card>
    </div>
  );
};

export default Login;
